import { render } from "./HomePlans.vue?vue&type=template&id=234a0490"
import script from "./HomePlans.vue?vue&type=script&lang=js"
export * from "./HomePlans.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__